import React, { useState } from 'react';
import { getCurrentUserEmail } from '../auth/auth';

export default function AppNavUser() {
    const [open, setOpen] = useState(false);
    const email = getCurrentUserEmail() || '';

    if (!email) return null;

    return (
        <span className={`app-nav-user${open ? ' is-open' : ''}`}>
            <button
                type="button"
                className="app-nav-user__button"
                aria-label={`Ingelogd als ${email}`}
                aria-expanded={open}
                aria-controls="app-nav-user-email"
                onClick={() => setOpen(value => !value)}
                onBlur={() => setOpen(false)}
            >
                <span className="material-symbols-outlined" aria-hidden="true">
                    account_circle
                </span>
            </button>
            <span id="app-nav-user-email" className="app-nav-user__popover" role="tooltip">
                {email}
            </span>
        </span>
    );
}
